const MoneyMgmtChallenge1InitialText ="It seems like people are often " +
    "worried about money and how to make 'ends-meet'.  What are some things that you can do to manage " +
    "money so that it does not become an ongoing problem? Move items that describe good money " +
    "management from the 'Considerations' column to the 'Good Financial Literacy Practices' column and " +
    "then click the 'Done' button." 
        
export default MoneyMgmtChallenge1InitialText 
 